<template>
  <vs-popup class="add-new-task-field" id="popup" :title="isCreateMode ? 'ADD TASK FIELD' : 'UPDATE TASK FIELD'"
    @close="open = false" :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-task-field-popup" @submit.prevent="handleSubmit(onClickCreateTaskField)" autocomplete="off">
          <div>
            <!-- Label -->
            <div class="mb-3 vx-row">
              <div class="w-full vx-col md:w-full md:mb-0">
                <vs-input v-model="form.label" label="Question or task name" class="w-full"
                  placeholder="Enter field label" />
              </div>
            </div>
            <!-- Field Required -->
            <div class="mb-3 vx-row">

            </div>
            <!-- Allocation -->
            <div class="mb-3 vx-row">
              <div class="w-full vx-col md:w-1/2 md:mb-0">
                <v-select name="type" v-model="form.type" :options=fieldTypes :reduce="option => option.value"
                  @input="clearOption()" placeholder="Select field type" />
              </div>
              <div class="w-full vx-col md:w-1/2 md:mb-0 flex items-center">
                <vs-checkbox v-model="form.is_required">
                  Field Required
                </vs-checkbox>
              </div>
            </div>
            <div v-if="form.type == 'Drop Down' || form.type == 'Scale'" class="mb-3 vx-row">
              <div class="w-full vx-col">
                <div class="mb-3" v-if="form.type == 'Scale'">
                  <div class="vx-row">
                    <div class="vx-col">
                      <div class="scale-field">
                        <label for="min">Min</label>
                        <vs-input type="number" id="min" v-model.number="form.options.min" placeholder="Enter minimum"
                          class="scale-input" @keydown="preventLeadingZero($event, 'min')" />
                      </div>
                    </div>
                    <div class="vx-col">
                      <div class="scale-field">
                        <label for="max">Max</label>
                        <vs-input type="number" id="max" v-model.number="form.options.max" placeholder="Enter maximum"
                          class="scale-input" @keydown="preventLeadingZero($event, 'min')" />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="form.type == 'Drop Down'">
                  <div v-if="checkMaxLength()">
                    <h4 class="mb-3">Add an Option</h4>
                    <div class="mb-3 vx-row">
                      <div class="vx-col w-2/5 md:w-2/5">
                        <label>Label:</label>
                        <div class="flex">
                        <vs-input v-model="newOption.label" placeholder="Enter label" />
                        <vs-button class="ml-2" style="height: 38px;" @click="addOption">Add</vs-button>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                  <!-- <div v-if="!checkMaxLength()">
                    Increase Scale to add more options...
                  </div> -->
                  <h4 class="mb-3">Options</h4>
                  <ul>
                    <li v-for="opt in form.options.labels">
                      <div class="flex items-center mb-2">
                        <vs-input class="mr-2" v-model="opt.label" placeholder="Enter label" /> <vs-button
                          @click.stop="onClickDeleteOption(opt)" size="small" color="danger" type="border"
                          icon-pack="feather" icon="icon-trash"></vs-button>
                      </div>
                    </li>
                    <li v-if="form.options.length === 0"
                      class="p-2 mb-1 border rounded bg-gray-100 text-gray-400 text-center">
                      No options added
                    </li>
                  </ul>
                </div>
              </div>
            </div>
           <div v-if="form.type == 'Table'" class="w-full vx-col">
            <div class="mb-3">
              <!-- Repeatable toggle -->
              <div style="display: flex; align-items: center; gap: 5px;">
                <span>Repeatable:</span>
                <vs-switch
                  v-model="table.is_repeatable"
                  color="success"
                ></vs-switch>
              </div>

              <!-- Add Column -->
              <vs-button type="filled" style="margin-top: 10px;" @click="addColumn">
                Add Column
              </vs-button>

              <!-- Columns list -->
              <div
                v-for="(Column, pIndex) in table.columns"
                :key="pIndex"
                style="margin-top: 5px; display: flex; gap: 10px; align-items: center;"
              >
                <vs-input
                  v-model="table.columns[pIndex]"
                  placeholder="Column Label"
                ></vs-input>

                <vs-button
                  size="small"
                  color="danger"
                  type="border"
                  icon-pack="feather"
                  icon="icon-trash"
                  @click="removeColumn(pIndex)"
                >
                  Remove Column
                </vs-button>
              </div>
            </div>
          </div>
            <!-- Description -->
            <div class="mb-3 vx-row">
              <div class="w-full vx-col md:w-full md:mb-0">
                <small class="label">End user briefing notes</small>
                <vs-textarea v-model="form.description" type="textarea" class="w-full" :rows="4"
                  placeholder="Enter field description" />
              </div>
            </div>
          </div>
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>

  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  function initialState() {
    return {
      open: false,
      id: '',
      fieldId:'',
      form: {
           options:{   
        labels:[]},
      },
      fieldTypes:[],
      newOption: {
        label: '',
      },
      isCreateMode: true,
        table: {
          is_repeatable: false,
          columns: [""] // now part of a single object
        }
    }
  }

  export default {
    name: 'CreateTaskField',
    data() {
      return initialState()
    },
    async mounted() {
    },
    components: {
    'v-select': vSelect,
    },
    methods: {
      async openPopup(data, fieldId) {
        try {
          Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.getFieldTypes();
          this.open = true;
          if (!!data) {
            this.fieldId = fieldId
            this.id = data.id
            this.form = data
            this.table = data.options.table
            this.isCreateMode = false
          } else {
            this.fieldId = fieldId
            this.isCreateMode = true
          }
        } catch (error) {

        }
      },
       preventLeadingZero(event, field) {
      const value = this.form.options[field];

      // Only prevent if the key is '0' and input is empty
      if (event.key === '0' && value.length === 0) {
        event.preventDefault();
      }

      // Optional: allow navigation keys (arrow keys, backspace, delete)
      const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
      if (allowedKeys.includes(event.key)) {
        return;
      }
    },
        addOption() {
            if(this.form.type == 'Drop Down'){
            const { label } = this.newOption
            if (!label) {
                return
            }
           
            // Add the new option
            this.form.options.labels.push({ label })
            this.newOption.label = ''
            }
            else if(this.form.type == 'Scale') {
                const { label } = this.newOption
            if (!label ) {
                return
            }
           
            // Add the new option
            if(this.checkMaxLength())
            this.form.options.labels.push({ label })
            this.newOption.label = ''
            }
            // Clear inputs
        
          
        },
        clearOption(){
          this.form.options = {labels:[]};
        },
        checkMaxLength(){
          return  this.form.type == 'Drop Down' ? true : this.form.type == 'Scale' && this.form.options.labels.length <= this.form.options.max - this.form.options.min
        },
        async getFieldTypes() {
            try {
                const { data } = await ScheduledTasksRepository.fieldTypes();
                // create a new array so Vue detects the change
                this.fieldTypes = data.data.sort((a, b) => a.label.localeCompare(b.label));
                this.fieldTypes = this.formattedFieldTypes()
            } catch (err) {
                console.error("Failed to load allocations:", err);
            }
        },
      async onClickCreateTaskField() {
        const vue = this;
        await this.$vs.loading({
          container: '#create-task-field-popup',
          scale: 0.45
        })
        try {
          let payload;
          if(this.form.type == 'Table'){
            payload = this.form;
            payload.options.table = this.table;
          }
          else {
            payload = this.form;
          }
          if (this.isCreateMode) {
            await ScheduledTasksRepository.createTaskField(this.fieldId,payload);
            this.showSuccessMessage('TaskField added successfully');
          } else {
            await ScheduledTasksRepository.updateTaskField(this.id, payload);
            this.showSuccessMessage('TaskField updated successfully');
          }
          this.open = false;
          this.$nextTick(async () => {
            await vue.$parent.refreshData();
          });
        
        } catch (e) {
          this.$vs.loading.close('#create-task-field-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#create-task-field-popup > .con-vs-loading')
      },
      onClickDeleteOption(opt) {
        const index = this.form.options.labels.indexOf(opt);
        if (index !== -1) {
          this.form.options.labels.splice(index, 1);
        }
      },
      formattedFieldTypes() {
      return this.fieldTypes.map(option => {
        option.label = option.label === 'Boolean' ? 'Yes / No Question' : option.label;
        return option;
      },
      );
      },
    addColumn() {
      this.table.columns.push(
         "",
      );
    },
    removeColumn(pIndex) {
      this.table.columns.splice(pIndex, 1);
    },
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .add-new-task-field >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 50% !important;
  }

</style>
